import { useEffect, useRef } from 'react';
import { useSlotScreenGeneratorStore } from '../store/slotScreenGeneratorStore';
import { loadComponentImage } from '../services/slot-screen-generator';
import { hasProjectRoot } from '../services/FileSystemService';
import { SLOT_SCREEN_ORDER } from '../../core/types/slot-screen-generator.types';

/**
 * Restores blob URLs for component results that were saved to disk.
 * Runs once on mount — reads each savedPath from disk and
 * updates the store with fresh blob URLs.
 */
export function useRestoreComponentImages() {
  const didRestore = useRef(false);

  useEffect(() => {
    if (didRestore.current || !hasProjectRoot()) return;
    didRestore.current = true;

    const restore = async () => {
      const store = useSlotScreenGeneratorStore.getState();

      for (const screenId of SLOT_SCREEN_ORDER) {
        const components = store.screenComponents[screenId];
        if (!components) continue;

        for (const comp of components) {
          for (const result of comp.generatedResults) {
            if (result.savedPath && !result.imageUrl) {
              const blobUrl = await loadComponentImage(result.savedPath);
              if (blobUrl) {
                useSlotScreenGeneratorStore
                  .getState()
                  .restoreComponentResultUrl(screenId, comp.id, result.id, blobUrl);
              }
            }
          }
        }
      }
    };

    restore().catch(() => {});
  }, []);
}
